import Image from 'next/image';
import styled from '@emotion/styled';

export const Container = styled.section`
  position: relative;
  display: flex;
  height: 380px;
  background-color: #03095c;
`;

export const Inner = styled.div`
  position: relative;
  padding-left: 86px;
  width: 100%;
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
`;

export const Text = styled.p`
  position: relative;
  padding-top: 86px;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  line-height: 52px;
  letter-spacing: -0.02px;
  z-index: 1;
`;

export const BtnContact = styled.button`
  position: relative;
  margin-top: 40px;
  padding: 16px 32px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  border: none;
  border-radius: 8px;
  background-color: #3449ff;
  z-index: 1;
`;

export const CommunityImage = styled(Image)`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 0;
`;
